module.exports = __webpack_public_path__ + "static/img/15c0a6f8.svg";